<template>
  <div class="search">
    <label v-if="label" :for="id">{{ label }}</label>
    <div class="mt-1 flex rounded-md shadow-sm">
      <div class="relative flex items-stretch flex-grow focus-within:z-10">
        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <ui-icon-search-solid class="h-5 w-5 text-gray-400"/>
        </div>
        <input type="text" :id="id" v-model.lazy.trim="inputText" :placeholder="placeholder" class="input">
        <div v-show="inputText" class="absolute block inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
             @click="clear">
          <ui-icon-x-solid class="clear-icon"/>
        </div>
      </div>
      <!--      <button class="sort-button" v-if="sort.length">
              <svg class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor"
                   aria-hidden="true">
                <path
                    d="M3 3a1 1 0 000 2h11a1 1 0 100-2H3zM3 7a1 1 0 000 2h5a1 1 0 000-2H3zM3 11a1 1 0 100 2h4a1 1 0 100-2H3zM13 16a1 1 0 102 0v-5.586l1.293 1.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 101.414 1.414L13 10.414V16z"/>
              </svg>
              <span>Сортировка</span>
            </button>-->
    </div>
  </div>
</template>

<script>
import rid from '@/utils/id'
import UiIconSearchSolid from "@/components/ui/icons/UiIconSearchSolid";
import UiIconXSolid from "@/components/ui/icons/UiIconXSolid";

export default {
  name: "UiSearchBox",
  components: {UiIconXSolid, UiIconSearchSolid},
  //emits: ['search'],
  props: {
    modelValue: {
      default: ''
    },
    placeholder: {
      default: 'Введите текст для поиска'
    },
    label: {
      default: null,
    },
    /*   sort: {
         type: Array,
         default: () => [],
       }*/

  },
  data() {
    return {
      id: rid('search_'),
      inputText: '',
    }
  },
  methods: {
    clear() {
      this.inputText = '';
    }
  },
  watch: {
    inputText(val) {
      this.$emit('update:modelValue', val)
    }
  }
}
</script>

<style lang="scss" scoped>

.search {
  > label {
    @apply block text-sm font-medium text-gray-700;
  }

  .input {
    @apply block w-full rounded-md px-10 sm:text-sm border-gray-300;
    &:focus {
      @apply ring-primary-500 border-primary-500;
    }
  }

  .sort-button {
    @apply -ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 ;
    &:focus {
      @apply outline-none ring-1 ring-primary-500 border-primary-500
    }

    &:hover {
      @apply bg-gray-100
    }
  }

  .clear-icon {
    @apply h-5 w-5 text-gray-400 cursor-pointer z-50;
    &:hover {
      @apply text-gray-600;
    }

  }

}


</style>